module.exports = __webpack_public_path__ + "static/button-04e13e13b442f93565009981710bd36a.svg";